import React from 'react';
import { useTranslate } from 'react-admin';
import { Box, FormControl, InputLabel, MenuItem, Select, Typography } from '@mui/material';

const ALL_VALUE = '__all__';

/**
 * Multi-session event ops: Tümü + her oturum (stock id).
 */
export const EventSessionScopeSelect = ({
  showSelect,
  sessionOptions = [],
  scopeStockId,
  onChange,
  loading = false,
}) => {
  const translate = useTranslate();

  if (!showSelect) return null;

  const value = scopeStockId || ALL_VALUE;

  return (
    <Box sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
      <FormControl size="small" sx={{ minWidth: 280 }} disabled={loading}>
        <InputLabel id="event-session-scope-label">
          {translate('form.session_scope', { _: 'Oturum' })}
        </InputLabel>
        <Select
          labelId="event-session-scope-label"
          label={translate('form.session_scope', { _: 'Oturum' })}
          value={value}
          onChange={(e) => {
            const next = e.target.value;
            onChange(next === ALL_VALUE ? null : next);
          }}
        >
          <MenuItem value={ALL_VALUE}>
            {translate('form.session_scope_all', { _: 'Tümü' })}
          </MenuItem>
          {sessionOptions.map((opt) => (
            <MenuItem key={opt.id} value={opt.id}>
              {opt.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Typography variant="body2" color="text.secondary">
        {translate('form.session_scope_hint', {
          _: 'Satış, bilet ve raporu oturuma göre filtreler.',
        })}
      </Typography>
    </Box>
  );
};

export default EventSessionScopeSelect;
